<template>
  <div>
    <AppModal
      v-show="modalToggle"
      @modalSignCancel="modalSignCancel"
      @modalSignCheck="modalSignCheck"
    />
    <header id='header'>
      <div class='inner'>
        <div class='col col1'>
          <a class='btnNavi prev'>
            <span @click.stop.prevent='backBtn' class='ico'>이전</span>
          </a>
        </div>
        <div class='col col2'>
        <!-- 마이페이지, 주문내역 -->
          <h1>{{$t(`${'MyPage.orderStore'}`)}}</h1>
        </div>
        <div class='btnNavi home' @click="appMoveMain()">
          <div class="ico">홈</div>
        </div>
      </div>
    </header>
    <Loading v-if="loading"/>
    <div class="orderStoreListWrap" v-else-if="historyLength > 0">
      <div v-for="(store, index) in orderStoreList" :key="index" class="orderStoreList">
        <div class="orderStoreTit">
          <h2 @click="storeIntroUrl(store)">{{store.storeName}}</h2>
          <div :class="store.likeFlag ? 'likeBtnActive' : 'likeBtn'" @click="likeBtnFlag(index)"></div>
          <div :class="store.dislikeFlag ? 'unlikeBtnActive' : 'unlikeBtn'" @click="unlikeBtnFlag(index)"></div>
        </div>
        <div class="orderStoreListContents">
          <div class="imageWrapper" v-if="store.imagePath">
            <img :src="store.imagePath" @click="storeIntroUrl(store)">
          </div>
          <div class="noImg" v-else>
            <img src="../assets/img/list_img_empty.png" @click="storeIntroUrl(store)">
          </div>
          <h3 class="orderMenu" @click="storeIntroUrl(store)">{{store.menuName}}</h3>
          <span>{{store.orderTime}}</span>
        </div>
      </div>
    </div>
    <div class="noMenu noOrder" v-else>
      <img src="../assets/img/ic_error_36.png" >
      <p>{{$t(`MyPage.noOrderStore`)}}</p>
    </div>
    <!-- <BottomMenu/> -->
  </div>
</template>

<script>
// import BottomMenu from '@/components/App/BottomMenu.vue'
import service from '@/backend/modnpay_app_api'
import Loading from '@/components/Common/Loading.vue'

export default {
  components: { Loading },
  data () {
    return {
      activeTab: 0,
      orderSearchType: 0,
      tabs: [
        {
          nameKo: '전체',
          nameEn: 'All',
          nameCn: '全部'
        },
        {
          nameKo: '음식',
          nameEn: 'Food',
          nameCn: '食物'
        },
        {
          nameKo: '쇼핑',
          nameEn: 'Shopping',
          nameCn: '购物'
        }
      ],
      orderStoreList: [],
      modalToggle: false,
      loading: true
    }
  },
  computed: {
    historyLength () { return this.orderStoreList ? this.orderStoreList.length : 0 }
  },
  updated () {
    sessionStorage.getItem('langType')
      ? this.$i18n.locale = sessionStorage.getItem('langType')
      : this.$i18n.locale = this.$store.getters.langType
  },
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    this.storeList()
  },
  methods: {
    backBtn () {
      history.back()
    },
    async storeIntroUrl (order) {
      const req = {
        urlCode: order.storeGroupCode,
        introUrlType: order.qrType
      }
      const { data } = await service.storeIntroUrl(req)
      // const { data } = await service.orderStoreIntroUrl(req)

      sessionStorage.removeItem('tradition')
      sessionStorage.removeItem('categoryCode')
      sessionStorage.removeItem('addressByLotNum')
      sessionStorage.removeItem('time')
      window.location.href = data.introUrl
    },
    async storeList (index) {
      this.activeTab = index === undefined ? 0 : index
      const req = {
        deviceId: localStorage.getItem('deviceId'),
        orderSearchType: this.activeTab,
        pageNumber: 1

      }
      const { data } = await service.storeList(req)
      if (data.resultCode == 0) {
        if (data.beforeWeek && !this.isUser) {
          this.modalToggle = true
        }
        this.orderStoreList = data.orderStoreList
      } else if (data.resultCode == 20001) {
        this.orderStoreList = []
      }
      this.loading = false
    },
    async storeIconUpdate (index) {
      const req = {
        storeCode: this.orderStoreList[index].storeCode,
        storeGroupCode: this.orderStoreList[index].storeGroupCode,
        likeFlag: this.orderStoreList[index].likeFlag,
        dislikeFlag: this.orderStoreList[index].dislikeFlag,
        orderSheetId: this.orderStoreList[index].orderSheetId
      }
      const { data } = await service.storeIconUpdate(req)
      if (data.resultCode == 0) {
        this.storeList()
      }
    },
    likeBtnFlag (index) {
      this.orderStoreList[index].likeFlag = !this.orderStoreList[index].likeFlag
      if (this.orderStoreList[index].dislikeFlag) {
        this.orderStoreList[index].dislikeFlag = false
      }
      this.storeIconUpdate(index)
    },
    unlikeBtnFlag (index) {
      this.orderStoreList[index].dislikeFlag = !this.orderStoreList[index].dislikeFlag
      if (this.orderStoreList[index].likeFlag) {
        this.orderStoreList[index].likeFlag = false
      }
      this.storeIconUpdate(index)
    },
    modalSignCancel () { // 회원가입 취소
      this.modalToggle = false
    },
    modalSignCheck () { // 회원가입 이동
      this.$router.push({ name: 'AppLogin' })
    }
  }
}
</script>

<style scoped>
</style>
